/* @flow */
import * as React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import ScrollWatch from 'components/ScrollWatch';
import LoadingIndicator from 'components/LoadingIndicator';

import { ChatGapMessage } from 'entities/ChatMessage';
import { GapMessage } from 'entities/Message';

export type GapMessageType = ChatGapMessage | GapMessage;

type Props = {
  message: GapMessageType,
  onVisible: ?(m: GapMessageType) => void,
};

export class GapMessageItem extends React.Component<Props, *> {
  componentDidMount() {
    // let MessageList scroll to the bottom first
    setTimeout(this.detectVisible, 0);
  }

  shouldComponentUpdate(nextProps: Props, nextState: *) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidUpdate() {
    // see if it's still visible after DOM updates
    setTimeout(this.detectVisible, 0);
  }

  detectVisible = () => {
    const alreadyVisible = this.refs.gapWatch && this.refs.gapWatch.isVisible();
    if (alreadyVisible) {
      this.handleVisible();
    }
  };
  handleVisible = () => {
    const { message, onVisible } = this.props;

    if (!onVisible) {
      return;
    }

    // temporary debugging in prod
    const validType = message instanceof ChatGapMessage || message instanceof GapMessage;
    if (!validType) {
      console.error('message prop not a gap', message.getType());
      return;
    }

    onVisible(((message: any): GapMessage));
  };

  render() {
    return (
      <li>
        <ScrollWatch onEnter={this.handleVisible} ref="gapWatch">
          <div className="MessageList-loading">
            <LoadingIndicator size="small" />
          </div>
        </ScrollWatch>
      </li>
    );
  }
}

export default GapMessageItem;
